import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateGroups } from "../../../actions/actionGroup";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import GroupForm from "../GroupForm/GroupForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Groups",path:"/groups",isActive: false},
    {name: "UpdateGroups",path:"/updategroup",isActive: true},
];

class UpdateGroup extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Group</strong>
                                </CardHeader>
                                <GroupForm
                                    updateGroups={this.props.updateGroups}
                                    groupId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateGroup.propTypes = {
    updateGroups: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    groups: state.groups.groups || []
}), 
dispatch => ({
    updateGroups: () => dispatch(updateGroups())
}))(UpdateGroup);


// WEBPACK FOOTER //
// ./src/views/Groups/UpdateGroup/UpdateGroup.js